<div
  class="d-flex flex-column w-100 h-100"
  *ngIf="_isEmpty; else executionsAvailableContent"
>
  <hs-panel-card header="No Executions Available">
    <p>No executions available for the current recon date.</p>
  </hs-panel-card>
</div>

<ng-template #executionsAvailableContent>
  <div class="d-flex flex-column w-100 h-100">
    <!--https://medium.com/@pietmichal/angulars-content-projection-trap-and-why-you-should-consider-using-template-outlet-instead-cc3c4cad87c9-->
    <ng-template [ngTemplateOutlet]="content"></ng-template>
  </div>
</ng-template>
